'use client'

import i18next from 'i18next'
import {initReactI18next, useTranslation as useTranslationOriginal} from 'react-i18next'
import resourcesToBackend from 'i18next-resources-to-backend'
import LanguageDetector from 'i18next-browser-languagedetector'
import {getOptions, languages} from './settings'

const runsOnServerSide = typeof window === 'undefined'

i18next
    .use(initReactI18next)
    .use(LanguageDetector)
    .use(resourcesToBackend((language: string, namespace: string) => import(`./locales/${language}/${namespace}.json`)))
    .init({
        ...getOptions(),
        lng: undefined, // let detect the language on client side
        detection: {
            order: ['path', 'htmlTag', 'cookie', 'navigator'],
        },
        preload: runsOnServerSide ? languages : []
    })

export function useI18n(language?: string, namespace?: string | undefined, options: { keyPrefix?: string } = {}) {
    let translationOriginal = useTranslationOriginal(namespace, options);

    let {i18n, t} = translationOriginal;

    return {
        ...translationOriginal,
        currentLanguage: i18n.resolvedLanguage,
        formatDate(day: string) {
            let date = new Date(day);

            return i18n.format(date, 'datetime', 'es');
        },
        formatPercent(val: number) {
            return t('percent', {val, lng: 'es'});
        }
    };
}
